import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class FriendDetailsService {

    getEventRoute = '/api/friendDetails/';

    constructor(private dataService: DataService) {
    };


    save(result: any) {
        return this.dataService.post('/api/friendDetails/saveFriendDetails', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getFriendDetailsById(friendId) {
        return this.dataService.getRecord('/api/friendDetails/getFriendDetailsById/' + friendId);
    }
    getAccountType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/getAccountType', refresh);
    }

    getBankDetails(refresh: boolean) {
        return this.dataService.getData('/api/friendDetails/getBankList', refresh);
    }

    getReferredUserList() {
        return this.dataService.getRecord('/api/friendDetails/getReferredUser');
    }

    getReferredUserBySearch(search) {
        return this.dataService.getRecord('/api/friendDetails/getReferredUserBySearch/' + search);
    }

    getBenificiaryInformation(id: number, refresh: boolean) {
        return this.dataService.getRecord('/api/friendDetails/GetBeneficiaryInformation/' + id);
    }

    payNow(result: any) {
        return this.dataService.post('/api/friendDetails/postUserCredit', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getVoucherValue(refresh: boolean) {
        return this.dataService.getData('/api/friendDetails/getVoucherValue', refresh);
    }

    getCustomerReferredUserDetails() {
        return this.dataService.getRecord('/api/friendDetails/getCustomerReferredUserDetails');
    }

    getReferredUserListByDateFilter(fromDate?: string, toDate?: string) {
        return this.dataService.getRecordWithParams('/api/friendDetails/getReferredUserListByDateFilter', { fromDate, toDate });
    }

    getHasAnyActiveRecords() {
        return this.dataService.getRecord('/api/friendDetails/getHasAnyActiveRecords');
    }

    getActiveEncryptedUserId() {
        return this.dataService.getRecord('/api/friendDetails/getActiveEncryptedUserId');
    }

     markAsPaid(data : any) {
        return this.dataService.post('/api/friendDetails/UpdateApplicationAsAmountCredited', data);
    }

}
